import { FutuAPI_GetBalanceUSDT } from '@/lib/api/futu'
import { WalletAPI_getFutuTransHistory } from '@/lib/api/wallet'
import { storeFutuExchange } from '@/stores/future/exchange'
import { storeFutuUserInfo } from '@/stores/future/userInfo'
import { storeFutuWSMarket } from '@/stores/future/wsMarket'
import { storeFutuWSUser } from '@/stores/future/wsUsers'
import { storeUserInfo } from '@/stores/userInfo/userInfo'
import { WalletAPI_getFutuTransHistory_Req } from '@/types/covestAPI/wallet'
import { useEffect, useState } from 'react'

const useFutures = () => {
  const BinanceExchangeInfo = storeFutuExchange((s) => s.BinanceExchangeInfo)
  const {
    loadInit,
    connect: marketConnect,
    isConnected,
    Start24hrTicker,
  } = storeFutuWSMarket((s) => ({
    loadInit: s.loadInit,
    connect: s.connect,
    isConnected: s.isConnected,
    Start24hrTicker: s.Start24hrTicker,
  })) // 마켓 웹소켓 신청
  const userWSConnect = storeFutuWSUser((s) => s.connect)
  const IsLogin = storeUserInfo((s) => s.IsLogin)
  const InitLoginInfo = storeFutuUserInfo((s) => s.InitLoginInfo)

  useEffect(() => {
    if (isConnected) {
      Start24hrTicker()
    }
  }, [isConnected])

  useEffect(() => {
    BinanceExchangeInfo() // exchangeInfo 받아오기
    marketConnect() // 마켓 연결
    loadInit()
    if (IsLogin()) {
      InitLoginInfo() // 유저 선물 관련 정보 가져오기 ( 포지션, 미체결, 즐겨찾기 )
      userWSConnect() // 유저 웹소켓 연결
    }
  }, [])

  // 선물 Estimated Balance
  const [futuEstimatedBalance, setFutuEstimatedBalance] = useState(0)

  // 선물 USDT 발란스
  const [futuBalanceUSDT, setFutuBalanceUSDT] = useState('')
  // 선물 미실현 손익
  const [unRealizedProfit, setUnRealizedProfit] = useState(0)
  // 선물 최대 출금
  const [futuMaxWithdrawAmount, setMaxWithdrawAmount] = useState('')

  // 선불 USDT 발란스 조회
  const getFutuBalanceUSDT = async () => {
    const res = await FutuAPI_GetBalanceUSDT()
    setFutuBalanceUSDT(res.balance)
    setMaxWithdrawAmount(res.maxWithdrawAmount)
  }

  // 선불 거래내역 조회
  const getFutuTransHistory = async (req: WalletAPI_getFutuTransHistory_Req) => {
    const res = await WalletAPI_getFutuTransHistory(req)
    return res
  }

  // 미실현손익을 가져오려면 FutuAPI_GetPositionList 포지션 리스트를 가져와서 m_Map_User_PositionInfo에 set 해주고
  //
  //

  return {
    futuBalanceUSDT,
    futuMaxWithdrawAmount,
    getFutuTransHistory,
    getFutuBalanceUSDT,
  }
}

export default useFutures
